//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    UNIT_TYPE_EVENTS_SEARCH_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    eventSearchUnitTypeEventsResult
} from 'Redux/actions';

function* searchUnitTypeEvents({ payload }) {
    try {
        let QUERY = `
            query searchUnitTypeEvents ($conditions: [UnitTypeEventSearchInput], $sort: [UnitTypeEventSortInput], $limit: Int, $offset: Int) {
                result: searchUnitTypeEvents (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        rawEvent
                        eventId
                        event {
                            id
                            name
                            color
                        }
                        active
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: payload,
                limit: 400,
                offset: 0,
                sort: {
                    field: "id",
                    order: "ASC"
                }
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(eventSearchUnitTypeEventsResult(data.result))
    } catch (exc) {
        yield put(eventSearchUnitTypeEventsResult())
        ExceptionManager(exc, 'Modules/events/.components/unitTypeEventsList/redux/saga', 'searchUnitTypeEvents');
    }
}

function* watchEventRequests() {
    yield takeEvery(UNIT_TYPE_EVENTS_SEARCH_REQUEST, searchUnitTypeEvents);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchEventRequests)
    ]);
}